import React from 'react';
import {Flex, Text, Input, Icon, PriorityIcon} from '@priority-software/priority-style-react';
import texts from '../../../texts';
import {useHover} from '../../../../../hooks/useHover';
import {helpPopoverRef} from '../../../../../_shared/Help/constants';
import styles from '../../../../ReportGenerator/styles.module.scss';

export const TopXInput = ({title, value, isMultiSeries, onChange}) => {
    const {setRef, isHovering} = useHover();

    const handleChange = event => {
        const isNumberRegEx = new RegExp(/^\d+$/);
        const value = event?.target?.value;
        if (value.length > 2) {
            return;
        }
        if (isNumberRegEx.test(value) || !value) {
            onChange(event);
        }
    };

    const handleCheckBoxHelp = e => {
        e.stopPropagation();
        const content = isMultiSeries ? texts.multiSeriesTopXHelp : texts.singleSeriesTopXHelp;
        helpPopoverRef.current.showHelpPopover({
            content,
            anchor: e.target
        });
    };

    return (
        <div ref={setRef} className={styles.axisWrapper}>
            <Flex
                direction="column"
                justifyContent="flex-start"
                alignItems="flex-start"
                componentClasses={styles.axisWrapper}
            >
                <Text skin="label-1" componentClasses={styles.titleWithHelp}>
                    {title}
                    {isHovering && (
                        <Icon
                            onClick={handleCheckBoxHelp}
                            skin="standart"
                            icon={PriorityIcon.help}
                        />
                    )}
                </Text>
                <Input
                    value={value}
                    onChange={e => handleChange(e)}
                    placeholder={texts.enterNumber}
                    size="large"
                    type="text"
                />
            </Flex>
        </div>
    );
};
